// extracted by mini-css-extract-plugin
export default {"flex":"Footer_flex__7qapb","lineFooter":"Footer_lineFooter__ARFRE","borda":"Footer_borda__Xvxo3","logo":"Footer_logo__nbq9m"};